/**
 * Created by esalazar on 9/11/17.
 * Dialog for The Automatic Event Insertion
 */
(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('PlanningAutomaticEventDialogController', PlanningAutomaticEventDialogController);

    PlanningAutomaticEventDialogController.$inject = ['$uibModalInstance', 'parameters', 'SoopkitchenUtils', '$uibModal'];

    function PlanningAutomaticEventDialogController( $uibModalInstance, parameters, SoopkitchenUtils, $uibModal) {
        var vm = this;

        vm.picker = { date: parameters.start};
        vm.picker2 = { date: parameters.end};
        vm.pickerPoint1 = { date: parameters.start};
        vm.pickerPoint2 = { date: parameters.end};
        vm.status = parameters.status;
        vm.planLabel =  parameters.id;
        vm.invalidateStartDate = false;
        vm.invalidateEndDate = false;
        vm.invalidateTimeSlot = true;
        vm.invalidateTimeSlotBackup = true;
        vm.dateField = null;
        vm.timeField = null;
        vm.separation = 24*3600;
        vm.duration = 3600;
        vm.unsuccesfulDates = null;
        vm.timeSlot = null;
        vm.backupTimeSlot = null;
        vm.isCoordBurstAutomatic = true;
        vm.checkLoader = false;

        vm.validateDate = validateDate;
        vm.validateTime = validateTime;
        vm.focusCallback = focusCallback;
        vm.focusCallbackTime = focusCallbackTime;
        vm.invalidateDateRange = invalidateDateRange;
        vm.clear = clear;
        vm.updateSeparationLetters = updateSeparationLetters;
        vm.updateSeparation = updateSeparation;
        vm.updateDurationLetters = updateDurationLetters;
        vm.updateDuration = updateDuration;
        vm.durationLettersInvalid = durationLettersInvalid;
        vm.separationLettersInvalid = separationLettersInvalid;
        vm.apply = apply;
        vm.check = check;
        vm.finish = finish;
        //initiate the date letter fields wit the default values separation = 1d and minimum duration = 1h;
        vm.updateSeparationLetters();
        vm.updateDurationLetters();

        function validateDate() {
            var isNotValid = false === SoopkitchenUtils.isValidDate(vm.dateField.value);
            if (vm.dateField.name === "startDate" ) {
                vm.invalidateStartDate = isNotValid;

            } else {
                vm.invalidateEndDate = isNotValid;
            }
        }

        function validateTime() {
            var isValid = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(vm.timeField.value);
            var isNotValid = false === isValid;
            if (vm.timeField.name === "timeSlot" ) {
                vm.invalidateTimeSlot = isNotValid;
            } else {
                vm.invalidateTimeSlotBackup = isNotValid;
            }
        }

        function clear() {
            location.reload();
        }

        function invalidateDateRange() {
            var endDateMilliseconds = Date.parse(vm.picker2.date).valueOf();
            var startDateMilliseconds = Date.parse(vm.picker.date).valueOf();
            return startDateMilliseconds > endDateMilliseconds;
        }

        function focusCallback($event) {
            if($event.target === null) {
                return;
            }
            vm.dateField = $event.target;
        }

        function focusCallbackTime($event) {
            if($event.target === null) {
                return;
            }
            vm.timeField = $event.target;
        }

        function updateSeparation() {
            vm.separation = SoopkitchenUtils.timeToSeconds (vm.lettersSeparation);
        }

        function updateSeparationLetters() {
            vm.lettersSeparation= SoopkitchenUtils.secondsToTime(vm.separation);
        }

        function updateDuration() {
            vm.duration = SoopkitchenUtils.timeToSeconds (vm.lettersDuration);
        }

        function updateDurationLetters() {
            vm.lettersDuration= SoopkitchenUtils.secondsToTime(vm.duration);
        }

        function durationLettersInvalid  () {
            if (vm.lettersDuration === null || vm.lettersDuration === undefined) return false;
            return (SoopkitchenUtils.timeToSeconds(vm.lettersDuration) === 0 || isNaN(SoopkitchenUtils.timeToSeconds(vm.lettersDuration)));
        }

        function separationLettersInvalid  () {
            if (vm.lettersSeparation === null || vm.lettersSeparation === undefined) return false;
            return (SoopkitchenUtils.timeToSeconds(vm.lettersSeparation) === 0 || isNaN(SoopkitchenUtils.timeToSeconds(vm.lettersSeparation)));
        }

        function getDates (response) {
            vm.checkLoader = false;
            if (response.eventsTimeline.happenings.length > 0) {
                vm.unsuccesfulDates = "Following events, for " + response.eventsTimeline.happenings.length/2 + " day(s), could not be created due to conflicts: \n";
                for (var i = 0; i < response.eventsTimeline.happenings.length ; i++) {
                    vm.unsuccesfulDates += response.eventsTimeline.happenings[i].startDate + " - " + response.eventsTimeline.happenings[i].endDate  + "\n";
                }
            }
            if (vm.unsuccesfulDates != null)
                response.comment  = vm.unsuccesfulDates + response.comment;
            vm.unsuccesfulDates = response.comment;
        }

        function check() {
            console.debug(vm.timeSlot);
            vm.unsuccesfulDates = null;
            vm.checkLoader = true;
            vm.status.check(vm.planLabel, new Date(Date.parse(vm.picker.date).valueOf()), new Date(Date.parse(vm.picker2.date).valueOf()),vm.duration, vm.separation, getDates, vm.timeSlot, vm.backupTimeSlot, vm.isCoordBurstAutomatic);

        }
        function apply() {

            vm.status.apply(vm.planLabel, new Date(Date.parse(vm.picker.date).valueOf()), new Date(Date.parse(vm.picker2.date).valueOf()),vm.duration, vm.separation, null, vm.timeSlot, vm.backupTimeSlot, vm.isCoordBurstAutomatic);
        }

        function finish() {
            vm.status.finish(vm.planLabel);
        }
    }

})();
